import Pallet from "./Pallet";
import {
  findDockDoorPosition,
  getLocalStorageItem,
} from "../../util/helper/helperFunctions";
import "../../assets/css/DockDoor/dockDoor.css";

const DockIcon = ({ plantConfig, dockData }) => {
  const mode = getLocalStorageItem("dockMode") ? "COMPLEX" : "SIMPLE";

  const getDockDoorNumber = (dockDoorName) =>
    Number(dockDoorName?.split(".")[1]);

  const isDockDoorPositionUP = findDockDoorPosition(plantConfig) === "UP";
  const isDockDoorManual = dockData[0]?.doorInManual === 1;

  const groupDockDoorByPosition = (dockData) => {
    const groupedData = Object.groupBy(dockData, ({ position }) => position);
    return isDockDoorPositionUP
      ? groupedData
      : Object.values(groupedData).toReversed();
  };

  const dockDoorHeader = () => {
    const elements = [
      <div
        key="mode"
        className={`dock-top-section-operation ${
          isDockDoorManual ? "dock-door-manual" : "dock-door-auto"
        }`}
      >
        {isDockDoorManual ? "M" : "A"}
      </div>,
      <div key="number" className="dock-top-section-number">
        {getDockDoorNumber(dockData[0]["dock"])}
      </div>,
    ];

    return (
      <div className="dock-top-section">
        {isDockDoorPositionUP ? elements : elements.reverse()}
      </div>
    );
  };

  const renderDocks = () =>
    Object.values(groupDockDoorByPosition(dockData)).map((value, index) => {
      if (mode === "COMPLEX") {
        return value.length === 1 ? (
          <Pallet
            key={index}
            status={value[0].palletStatus}
            className="dock dock-small"
          />
        ) : (
          <div key={index} className="dock dock-big">
            <Pallet
              status={value[0].palletStatus}
              className="dock dock-big-complex-left"
            />
            <Pallet
              status={value[1].palletStatus}
              className="dock dock-big-complex-right"
            />
          </div>
        );
      }

      // SIMPLE mode
      return (
        <Pallet
          key={index}
          status={value[0].palletStatus}
          className={`dock ${value.length === 1 ? "dock-small" : "dock-big"}`}
        />
      );
    });

  const dockDoorOrientation = [
    dockDoorHeader(),
    <div key="pallets" className="dock-bottom-section">
      {dockData && renderDocks()}
    </div>,
  ];

  return (
    <div className="dock-container">
      {isDockDoorPositionUP
        ? dockDoorOrientation
        : dockDoorOrientation.reverse()}
    </div>
  );
};

export default DockIcon;
